<template>
    <a-card :bordered="false">
       <a-form :labelCol="{span:2}" :wrapperCol="{span:22}" :model="form" ref="formRef" :rules="rules">
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 m-b-20">礼品信息</p>
            <a-form-item label="礼品信息" name="gift_list">
                 <a-button type="primary" :disabled="$route.query.type=='edit'" @click="showModal=true">请选择</a-button>
            </a-form-item>
            <a-form-item :wrapperCol="{span:22,offset:1}">
                <a-table :columns='columns' rowKey='gift_id' :data-source='gift_list' bordered :pagination="false">
                    <template v-slot:gift="{record}">
                          <div style="display: flex;align-items: center;">
                              <img :src="info.picdomain+'/'+record.gift_image" style="width:60px;height:60px;border:1px solid #eee;border-radius:6px"/>
                              <span class="m-l-10 s_omit2">{{record.gift_name}}</span>
                          </div> 
                      </template>
                      <template v-slot:action="{ record }">
                          <a-button type="primary" danger ghost @click="delGift(record)">删除</a-button>
                      </template>
                </a-table>
            </a-form-item>
            <a-form-item label="礼品分类" required>
                  <a-select v-model:value="form.gift_category_id" style="width:160px;" placeholder="请选择礼品分类">
                      <!-- <a-select-option value="">全部</a-select-option> -->
                      <a-select-option :value="item.id" v-for="(item,index) in category_list" :key="index">{{item.name}}</a-select-option>
                  </a-select>
            </a-form-item>
            <p class="s_fonts20 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 m-b-20">兑换规则</p>
            <a-form-item label="可兑数量" name="gift_num">
                <a-input-number type="number" v-model:value="form.gift_num" placeholder="请输入礼品库存数" :precision="0" :min="0" style="width:260px"></a-input-number>
            </a-form-item>
            <a-form-item label="可兑价格" name="price_type">
                <a-checkbox-group v-model:value="form.price_type" >
                    <a-checkbox  value="1" @change="changeCheckbox">积分支付</a-checkbox>
                     <a-checkbox value="2" @change="changeCheckbox">组合支付</a-checkbox>
                </a-checkbox-group>
                <template v-if="form.price_type.some((v)=>v=='1')">
                    <div>
                        <a-input-number v-model:value="form.first_point" style="width:260px" :precision="0" :min="1" placeholder="请输入积分数"></a-input-number>
                        <span class="m-l-10">积分</span>
                    </div>
                </template>
                <template v-if="form.price_type.some((v)=>v=='2')">
                    <div>
                        <a-input-number v-model:value="form.second_point" style="width:140px" :precision="0" :min="1" placeholder="请输入积分数"></a-input-number>
                        <span class="m-l-10">积分 +</span>
                        <a-input-number v-model:value="form.second_price" style="width:140px" :precision="2" :min="0.01" placeholder="请输入金额" class="m-l-10"></a-input-number>
                        <span class="m-l-10">元</span>
                    </div>
                </template>
            </a-form-item>
            <a-form-item label="兑换权限" name="is_limit">
                <a-radio-group class="m-l-10" v-model:value="form.is_limit">
                    <a-radio :value="1">限兑数量</a-radio>
                    <a-radio :value="2">不限数量</a-radio>
                </a-radio-group>
                <template v-if="form.is_limit==1">
                    <div>
                        <span class="m-r-10">每人兑换:</span>
                       <a-input-number v-model:value="form.limit" style="width:190px" :precision="0" :max="form.gift_num" :min="1" placeholder="请输入限兑数量"></a-input-number>
                        <span class="s_c999 fz-12">（不可超出可兑数量）</span>
                    </div>
                </template>
            </a-form-item>
            <a-form-item label="运费设置">
                <a-select v-model:value="form.freight_tmp_name" @change="changeFreight" style="width:180px" placeholder="请选择运费模板">
                    <a-select-option :value="item.delivery_id" v-for="(item,index) in deliveryList" :key="index">{{item.delivery_name}}</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item :wrapperCol="{span:24,offset:2}">
                <a-button type="primary" @click="submit">上架</a-button>
            </a-form-item>
       </a-form>

       <a-modal  title="选择礼品" v-model:visible="showModal" destroyOnClose :width="1000" :footer="null">
          <giftSku @selectSku="selectSku" :selecGift="gift_list" ></giftSku>
       </a-modal>
    </a-card>
</template>

<script>
import { onMounted, reactive,ref, toRefs,inject } from 'vue'
import { iscode } from '../../../utils/app';
import { message } from 'ant-design-vue';
import {getCategoryList,deliveryList,giftAdd,giftDetails,giftEdit} from "@/api/guide";
import giftSku from './components/giftSku'
import store from "@/store";
const columns = [
    {
        title: "礼品名称",
        dataIndex: "gift",
        key: "gift",
        slots:{customRender:'gift'}
    },
    {
        title: "规格",
        dataIndex: "gift_sku_name",
        key: "gift_sku_name",
    },
    {
        title: "价格/元",
        dataIndex: "gift_price",
        key: "gift_price",
    },
    {
        title: "操作",
        dataIndex: "action",
        key: "action",
        slots:{customRender:'action'},
        width:120
    }
]
export default{
    components:{giftSku},
    setup() {
        const form = ref({
              gift_category_id:null,
              price_type:['1'],
              gift_num:'',
              second_point:'',
              second_price:'',
              is_limit:1,
              limit:'',
              freight_tmp_name:null,
              freight_tmp_id:0,
              first_point:'',
              gift_id:'',
              gift_sku:'',
        })
        const formRef=ref(null) 
        const state = reactive({
            info: store.state.user.info,
              list:[],
              deliveryList:[],
              category_list:[],
              gift_list:[],
              showModal:false,
              rules:{
                  gift_num:[{required: true,message:'请输入礼品库存数!'}],
                  is_limit:[{
                      required: true,
                      validator:async (rule, value) => {
                          if(form.value.is_limit == 1){
                             if(!form.value.limit){
                                return Promise.reject('请输入限兑数!')
                             }else{
                                return Promise.resolve();
                             }
                          }else{
                              return Promise.resolve();
                          }
                      }
                  }],
                  price_type:[
                      {
                          required: true,
                          validator:async (rule, value) => {
                               if(form.value.price_type.some((v)=>v=='1')){
                                    if(!form.value.first_point){
                                      return Promise.reject('请输入积分数!')
                                    }else{
                                        if(form.value.price_type.some((v)=>v=='2')){
                                         if(!form.value.second_point||!form.value.second_price){
                                               return Promise.reject('请输入积分数或金额!')
                                         }
                                        }
                                    }
                               }else if(form.value.price_type.some((v)=>v=='2')){
                                    if(!form.value.second_point||!form.value.second_price){
                                          return Promise.reject('请输入积分数或金额!')
                                    }
                               }else{
                                   return Promise.reject('请选择兑换价格方式！')
                               }
                          }
                      }
                  ],
                  gift_list:[
                      {
                        required: true,
                         validator:async (rule, value) => {
                             if(state.gift_list.length==0){
                                 return Promise.reject('请选择礼品!')
                             }else{
                                 return Promise.resolve();
                             }
                         }
                      }
                  ]
              }
        })
         const $router = inject("$router");
          const $route = inject("$route");
        const methods = {
            changePaymentType(e){
               if(e.target.value==1){
                  form.value.second_point = '';
                  form.value.second_price = '';
               }else{
                  form.value.first_point = "";
               }
            },
           async getDelivery(){
                let res = await deliveryList().then(res=>res.data);
                if(iscode(res)){
                    console.log(res)
                    state.deliveryList = res.data.data || [];
                    form.value.freight_tmp_id = state.deliveryList[0].delivery_id;
                    form.value.freight_tmp_name = state.deliveryList[0].delivery_name;
                }else{
                    message.error(res.msg)
                }
            },
            changeFreight(e){
                  form.value.freight_tmp_id = e;
            },
           async submit(){
                await formRef.value.validate().then(async () => {
                    const hide = message.loading("正在加载中...", 0);
                    let res;
                     if($route.query.type=='add'){
                         res = await giftAdd({...form.value}).then(res=>res.data)
                     }else{
                         res = await giftEdit({...form.value,id:$route.query.id}).then(res=>res.data)
                     }
                     console.log(res);
                    setTimeout(hide)
                    if(iscode(res)){
                      $router.go(-1);
                    }else{
                         message.error(res.message)
                    }
                 }).catch(error => {
                     message.error('请完善表单!')
                 })
            },
            delGift(record){
                // console.log(record)
                 state.gift_list = [];
            },
     async categoryList(){
                let res = await getCategoryList({limit:1000,page:1}).then(res=>res.data);
                if(iscode(res)){
                     state.category_list = res.data.data || [];
                     form.value.category_list
                }else{
                    message.error(res.msg)
                }
            },
            selectSku(data){
                console.log(data)
                state.gift_list = [data];
                form.value.gift_id = data.gift_id;
                form.value.gift_sku = data.gift_sku;
                console.log(form.value,'999')
                state.showModal = false;
            },
            async getGiftDetails(){
                const hide = message.loading("正在加载中...", 0);
                let res =await giftDetails({id:$route.query.id}).then(res=>res.data);
                setTimeout(hide)
                if(iscode(res)){
                    state.gift_list = new Array(res.data.gift) || [];
                    form.value =res.data;
                    form.value.gift_category_id = res.data.category['gift_category_id'] || null;
                    form.value.gift_sku = res.data.gift['gift_sku'] || '';
                    form.value.gift_id = res.data.gift['gift_id'] || '';
                    form.value.price_type = res.data.price_type.map((v)=>String(v))
                    form.value.freight_tmp_name = res.data.delivery['delivery_name']
                    form.value.freight_tmp_id = res.data.delivery['freight_tmp_id']
                }else{
                     message.error(res.msg)
                }
            },
            changeCheckbox(e){
                 if(e.target.value==1){
                      if(e.target.checked){
                         form.value.first_point = null;
                      }
                 }else{
                    if(e.target.checked){
                         form.value.second_point = null;
                         form.value.second_price = null;
                      }
                 }
            }
        }
        onMounted(()=>{
            methods.getDelivery()
            methods.categoryList()
            if($route.query.type == 'edit'){
                methods.getGiftDetails()
            }
        })
        return{
            ...toRefs(state),
            columns,
            form,
            ...methods,
            formRef
        }
    },
}
</script>
